import React from 'react'
import { Link } from 'react-router-dom'

const EconomicCalendar = () => {
    return (
        <section className='section'>
            <h1 className='h2 mb-10 lg:mb-20 text-center text-black'>Economic Calendar</h1>

            <div className='container justify-center items-center mx-auto text-black h-full w-full font-primary '>
                <iframe title='test' src="https://sslecal2.investing.com?columns=exc_flags,exc_currency,exc_importance,exc_actual,exc_forecast,exc_previous&features=datepicker,timezone&countries=25,34,32,6,37,72,71,22,17,51,39,14,33,10,35,43,60,45,38,36,110,11,26,9,12,41,4,5,178&calType=day&timeZone=28&lang=62"
                    width="1000"
                    height="500"
                    frameborder="100"
                    allowtransparency="true"
                    marginwidth="100"
                    marginheight="100">
                </iframe>
                <span className='mt-5'>Real Time Economic Calendar provided by 
                    <Link to="https://ph.Investing.com/" target="_blank" className="text-sky-400"> Investing.com Philippines</Link>.
                </span>
                {/* <div className="poweredBy" style={{font-family: ['Arial',' Helvetica', 'sans-serif']}}>
                <span style="font-size: 11px;color: #333333;text-decoration: none;">Real Time Economic Calendar provided by
                    <a href="https://ph.Investing.com/" rel="nofollow" target="_blank" style="font-size: 11px;color: #06529D; font-weight: bold;" 
                        className="underline_link">Investing.com Philippines</a>.
                </span>
            </div> */}
            </div>
        </section>
    )
}

export default EconomicCalendar
